import i18n from "../lang/i18n";

const validations = {
  name: {
    required: true,
    maxLength: 255
  },
  title: {
    required: true,
    maxLength: 255
  },
  password: {
    required: true,
    maxLength: 10,
    format: {
      valid: value => /^[A-Za-z\d@_*-]{0,10}$/.test(value.trim()),
      message: i18n.t("zoom_meeting.password_invalid")
    }
  },
  start_date_time: {
    required: true
  },
  start_date: {
    required: true
  },
  end_date: {
    required: true
  },
  duration: {
    required: true,
    format: {
      valid: value => value <= 1000 && value >= 0,
      message: i18n.t("validation.duration")
    }
  },
  notification: {
    format: {
      valid: value => value <= 1000 && value >= 0,
      message: i18n.t("validation.notification_before")
    }
  }
};
export { validations };
